import template from './headers-builder.html';

const headersBuilderDirective = /* @ngInject */ () => ({
	scope: {
		data: '=',
		label: '@',
		tooltipText: '@',
		valueLabel: '@',
		labelHeader: '@',
		valueProperty: '@',
		headerProperty: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	link: (/** @type {any} */ scope) => {
		scope.valueProperty = scope.valueProperty || 'value';
		scope.headerProperty = scope.headerProperty || 'header';
		scope.valueLabel = scope.valueLabel || 'Value';
		scope.labelHeader = scope.labelHeader || 'Header';
		scope.data = scope.data || [];

		scope.addValue = () => {
			/** @type {any} */
			const object = {};
			object[scope.valueProperty] = '';
			object[scope.headerProperty] = '';
			scope.data.push(object);
		};

		scope.removeValue = (/** @type {number} */ index) => {
			scope.data.splice(index, 1);
		};
	},
});

export default headersBuilderDirective;
